/* eslint-disable no-undef */
import "./sentry";
import React from "react";
import ReactDOM from "react-dom";
import ReactGA from "react-ga";

import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import "react-toastify/dist/ReactToastify.css";
import "react-table/react-table.css";
import "animate.css/animate.min.css";
import "react-tooltip/dist/react-tooltip.css";

import { createBrowserHistory as createHistory } from "history";

import { configureStore } from "./store/configureStore";
import "./styles/styles.scss";
import "./styles/images";

import App from "./components/App";

import MaintenceMode from "./components/modes/MaintenanceMode";
import { injectStore } from "./lib";

const history = createHistory();
const store = configureStore({}, history);

injectStore(store);

// Universal Analytics
const TRACKING_ID = "UA-137244351-15";

ReactGA.initialize(TRACKING_ID);

history.listen((location) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

const checkiOS = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return true;
  }

  return false;
};

if (checkiOS()) {
  import("./styles/ios.scss");
}

const AppContainer = () =>
  import.meta.env.VITE_MAINTENANCE_MODE === "true" ? (
    <MaintenceMode />
  ) : (
    <Provider store={store}>
      <Router history={history}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </Router>
    </Provider>
  );

ReactDOM.render(<AppContainer />, document.getElementById("app"));
